import { render } from "./GithubLink.vue?vue&type=template&id=09d54a70&scoped=true"
import script from "./GithubLink.vue?vue&type=script&lang=js"
export * from "./GithubLink.vue?vue&type=script&lang=js"

import "./GithubLink.vue?vue&type=style&index=0&id=09d54a70&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d54a70"]])

export default __exports__